/**
 * @prettier
 */

const SelectInput = ({
    error,
    isRequired,
    label,
    config,
    onChange,
    onBlur = () => {},
    actionDataLabel,
    defaultValue,
    options,
}) => {
    const placeholderText = config.placeholder ?? "Select";
    const selectedValue = defaultValue ?? "";

    return (
        <div className={`custom-select-wrapper ${error ? "error" : ""}`}>
            <select
                className="custom-select"
                id={config.id}
                onChange={onChange}
                onBlur={onBlur}
                value={selectedValue}
                data-dd-action-name={actionDataLabel}
            >
                <option value="" disabled hidden={selectedValue !== ""}>
                    {placeholderText}
                </option>
                {options.map(option => (
                    <option
                        key={option[config.optionValue]}
                        value={option[config.optionValue]}
                    >
                        {option[config.optionName]}
                    </option>
                ))}
            </select>
            <label
                id={config.id}
                className={`custom-label ${isRequired ? "required" : ""}`}
                style={{ position: "absolute" }}
            >
                {label}
            </label>
            {error && <span className="error-text">{error}</span>}
        </div>
    );
};

export default SelectInput;
